import { travelerFromFirestore } from '@parallel-fluidics/shared/models/travelers';
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

/**
 * Fetch the travelers that had parts from this lot installed — the
 * downstream traveler hop of the genealogy graph. Travelers gain the
 * root-level componentLotIds array when the install flow lands; until
 * then this simply returns no matches.
 */
export default async function fetchTravelersUsingLot(lotId) {
  const travelersQuery = query(
    collection(getFirestore(), 'travelers'),
    where('componentLotIds', 'array-contains', lotId),
  );
  const snapshot = await getDocs(travelersQuery);
  return snapshot.docs.map((travelerDoc) => travelerFromFirestore(travelerDoc));
}
